import {takeEvery} from 'redux-saga/effects'
import {
  GET_SYSTEM_LOGS,
  GET_SYSTEM_LOGS_SUMMARY,
  GET_SYSTEM_PROCESSES_LOGS,
  GET_SYSTEM_REQUEST_LOGS,
} from 'setup/redux/Actions/SystemLog/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_SYSTEM_LOGS, fetchData)
  yield takeEvery(GET_SYSTEM_REQUEST_LOGS, fetchData)
  yield takeEvery(GET_SYSTEM_LOGS_SUMMARY, fetchData)
  yield takeEvery(GET_SYSTEM_PROCESSES_LOGS, fetchData)
}

export default dataSaga
